import {Observable, ReplaySubject, Subject} from "rxjs";
import {OrderAdvice} from "../../place-order-wizard/models/OrderAdvice";

export class AdviceStore {
    private _advice: ReplaySubject<OrderAdvice | null | undefined> = new ReplaySubject(1);
    private _destroy$ = new ReplaySubject<boolean>(1);

    get advice$(): Observable<OrderAdvice | null | undefined> {
        return this._advice.asObservable().takeUntil(this._destroy$);
    }

    public setAdvice(advice: OrderAdvice | null) {
        this._advice.next(advice);
    }

    public clearAdvice() {
        this._advice.next(null);
    }

    public updateAdvice(updatedFields?: OrderAdvice | null) {
        console.debug("Updated advice", updatedFields);
        this._advice.next(updatedFields);
    }

    public destroy() {
        this._destroy$.next(true);
        this._destroy$.complete();
        this._advice.complete();
    }
}
